import {
  ConfirmSheet,
  type ConfirmSheetProps,
} from "@rosc/ui/v32/confirm-sheet";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

// The v3.2 confirmation is @rosc/ui's ConfirmSheet
// (packages/ui/src/v32/confirm-sheet.tsx); this wrapper only defaults the
// Cancel label to the app's translation.
export const V3ConfirmSheet = ({
  cancelLabel,
  ...props
}: Omit<ConfirmSheetProps, "cancelLabel"> & {
  cancelLabel?: string;
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <ConfirmSheet cancelLabel={cancelLabel ?? t("common.cancel")} {...props} />
  );
};
